export default "__VITE_ASSET__9b983b5a__"